// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2HuQG","dragIcon":"SortableItem_dragIcon__6Y0f6","disabled":"SortableItem_disabled___Auff"};